import { ComponentPropsWithoutRef } from 'react';
import { twMerge } from 'tailwind-merge';

interface FilterContainerProps extends ComponentPropsWithoutRef<'div'> {}

const FilterContainer = (props: FilterContainerProps) => {
    const { className = '', children, ...rest } = props;
    return (
        <div
            className={twMerge(className, 'flex min-w-72 max-w-96 flex-col gap-1.5 px-4 py-3')}
            {...rest}
        >
            {children}
        </div>
    );
};

export { FilterContainer };
